import api from './api';
import { API_USAGE_STATS_BY_API_KEY } from '../configs/routes';

export const fetchApiUsageStatsByApiKey = (start_date, end_date, api_key, timeframe) => {
  const params = new URLSearchParams({ start_date, end_date });
  if (api_key) params.append('api_key', api_key);
  if (timeframe) params.append('timeframe', timeframe);
  const url = `${API_USAGE_STATS_BY_API_KEY}?${params.toString()}`;
  return api.get(url);
};

export const fetchApiUsageStatsByEndpoint = (start_date, end_date, api_key, timeframe) => {
  const params = new URLSearchParams({ start_date, end_date });
  if (api_key) params.append('api_key', api_key);
  if (timeframe) params.append('timeframe', timeframe);
  const url = `/api/expose/api-usage-stats/by-endpoint?${params.toString()}`;
  return api.get(url);
}; 